const FIRST_NAME_REGEX = /^(?=.{1,50}$)[a-zA-Z]+(?:[-'\s][a-zA-Z]+)*$/;
const LAST_NAME_REGEX = /^(?=.{1,50}$)[a-zA-Z]+(?:[-'\s][a-zA-Z]+)*$/;
const EMAIL_REGEX = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
const DATE_REGEX = /^\d{2}-\d{2}-\d{4}$/;
const DIGIT_ONLY_REGEX = /\D/g;
const NUMERIC_INPUT_REGEX = /^-?\d*$/;
const DATE_MASK = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]; // MM/DD/YYYY
const REGEX_WITH_ACCENTEDCHARS = /^(?:[A-Za-zÀ-ÖØ-öø-ÿ][A-Za-zÀ-ÖØ-öø-ÿ' .-]*|)$/;
const COMPLETE_INPUT = /_/; // check if string has underscore -- complete if input is completely filled is masked ex - 21/__/____ 
const MASK_SMS = /(\d{3})(\d{3})(\d{4})/; // Example - 123-456-7890 → xxx-xxx-7890
const MASK_EMAIL = /^(.)(.*)(@.*)$/; // Example - jdoe@example.com → j******@example.com
const SPECIAL_CHARACTERS_REGEX = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
const ALPHA_NUMERIC_REGEX = /^[0-9A-Za-z -]+$/; // Example - "John Doe 123"
const INTEGER_REGEX = /^-?\d+$/; // Match -> -123, 0, 123, 1234567890, No match -> 123.45, 123abc, abc123, 123abc456
const DATE_OF_BIRTH = /^\d{2}\/\d{2}\/\d{4}$/; // Examples: "12/31/1999" (Match), "01/01/2023" (Match), "31/12/1999" (No match)
const SSN_REGEX = /^[0-9]{4}$/; // Examples: "1234" (Match), "5678" (Match), "12345" (No match), "abcd" (No match)
const ZIP_CODE_REGEX = /^[0-9]{5}$/; // Examples: "12345" (Match), "67890" (Match), "1234" (No match), "123456" (No match)
const PHONE_REGEX = /^\(\d{3}\) \d{3}-\d{4}$/; // Examples: "(123) 456-7890" (Match), "(987) 654-3210" (Match), "123-456-7890" (No match), "(123)456-7890" (No match)
const COUNTY_REGEX = /^[a-zA-Z .]+$/; // Examples: "Los Angeles" (Match), "San Francisco" (Match), "New York" (Match), "123 County" (No match), "County@Name" (No match)
const HOUSEHOLD_REGEX = /^[0-9]$/; // Examples: "0" (Match), "5" (Match), "9" (Match), "10" (No match), "a" (No match)
const COUNT_REGEX = /^[0-9]+$/; // Examples: "123" (Match), "0" (Match), "456789" (Match), "123abc" (No match), "abc123" (No match)
const MEDICAID_ID_REGEX = /^[0-9a-zA-Z-]{1,30}$/; // Examples: "12345" (Match), "ABC-12345" (Match), "123-ABC-6789" (Match), "123456789012345678901234567890" (Match), "1234567890123456789012345678901" (No match), "123@ABC" (No match)
const INPUT_SSN_REGEX = /-/g;
const APHABETIC_REGEX = /^[A-Za-z\s]+$/;
const CITY_REGEX = /^[A-Za-z\s'\.\-]+$/; // Example: "New York" (Match), "Los Angeles" (Match), "San Francisco"

export {
    DATE_REGEX,
    DIGIT_ONLY_REGEX,
    EMAIL_REGEX,
    FIRST_NAME_REGEX,
    LAST_NAME_REGEX,
    NUMERIC_INPUT_REGEX,
    REGEX_WITH_ACCENTEDCHARS,
    DATE_MASK,
    COMPLETE_INPUT,
    MASK_SMS,
    MASK_EMAIL,
    SPECIAL_CHARACTERS_REGEX,
    INTEGER_REGEX,
    DATE_OF_BIRTH,
    SSN_REGEX,
    ZIP_CODE_REGEX,
    PHONE_REGEX,
    COUNTY_REGEX,
    COUNT_REGEX,
    MEDICAID_ID_REGEX,
    ALPHA_NUMERIC_REGEX,
    HOUSEHOLD_REGEX,
    INPUT_SSN_REGEX,
    APHABETIC_REGEX,
    CITY_REGEX
};
